import { motion } from "framer-motion";
import { Sparkles, User } from "lucide-react";
import ProjectSlider from "./ProjectSlider";


export default function ChatMessage({ message }) {
  const isBot = message.sender === "bot";

  return (
    <motion.div
      initial={{ opacity: 0, y: 15, scale: 0.98 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      transition={{ duration: 0.3 }}
      className={`flex items-end gap-2 ${isBot ? "justify-start" : "justify-end"}`}
    >
      {/* Bot Avatar */}
      {isBot && (
        <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-xl bg-gradient-to-br from-violet-600 via-fuchsia-600 to-pink-500 text-white shadow-lg">
          <Sparkles size={15} />
        </div>
      )}

      {/* Message Bubble */}
      <div
        className={`max-w-[80%] rounded-3xl px-2 py-2 shadow-lg ${
          isBot
            ? "rounded-bl-md bg-white/10 backdrop-blur-xl border border-white/10 text-white"
            : "rounded-br-md bg-gradient-to-r from-violet-600 to-fuchsia-600 text-white"
        }`}
      >
                    <>
                {message.type==="project-slider" ? (

                <ProjectSlider
                projects={message.projects}
                />

                ):(

                <p className="whitespace-pre-line text-[12px] leading-4">
                {message.text}
                </p>

                )}
                </>
      </div>

      {/* User Avatar */}
      {!isBot && (
        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-white/10 border border-white/10 text-white backdrop-blur-xl">
          <User size={18} />
        </div>
      )}
    </motion.div>
  );
}